import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@blueprintjs/core";

const LoginButton = () => {
  const { loginWithRedirect, isLoading, error } = useAuth0();

  const handleLogin = () => {
    console.log("Login button clicked");
    console.log("Auth0 state:", { isLoading, error });
    console.log("Current URL:", window.location.href);
    localStorage.clear();
    try {
      loginWithRedirect({
        redirectUri: window.location.origin,
        audience: "https://newchart.us.auth0.com/api/v2/",
        scope: "read:current_user openid profile email"
      });
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  if (error) {
    console.error("Auth0 error:", error);
    return (
      <div>
        <Button
          onClick={handleLogin}
          minimal
          large
          icon="log-in"
          intent="danger"
          disabled={isLoading}
        >
          {isLoading ? "Logging in..." : "Retry Login"}
        </Button>
        <div style={{ color: 'red', marginTop: '10px' }}>
          Error: {error.message}
        </div>
      </div>
    );
  }

  return (
    <Button
      onClick={handleLogin}
      minimal
      large
      icon="log-in"
      intent="success"
      disabled={isLoading}
    >
      {isLoading ? "Logging in..." : "Log In"}
    </Button>
  );
};

export default LoginButton;
